import { useCallback } from 'react'

import { FormChangedHandler, useFormData } from 'brief-form'

import { useSyncFormData } from '../../hooks'
import {
  CompanyPhysicalAddressChangeHandler,
  CompanyPhysicalAddressFormData,
  CompanyPhysicalAddressFormValue
} from '../../types/forms'

export const useCompanyPhysicalAddressForm = ({
  companyIndex,
  formData,
  onChange
}: {
  companyIndex: number
  formData: CompanyPhysicalAddressFormData
  onChange: CompanyPhysicalAddressChangeHandler
}) => {
  const onFormChanged: FormChangedHandler<CompanyPhysicalAddressFormValue> = useCallback(
    (formValues, formErrors) => onChange({ companyIndex, formData: { formValues, formErrors } }),
    [onChange, companyIndex]
  )

  const { config, Field, set } = useFormData<CompanyPhysicalAddressFormValue>({
    onFormChanged,
    initialValue: formData.formValues,
    initialErrors: formData.formErrors
  })

  useSyncFormData({ set, formData })

  return { Field, config }
}
